export default __webpack_public_path__ + "static/media/labMarker.43f86b4c.svg";